export const OptionGroup = ({ label, options, value, onChange, testPrefix, cols = 3 }) => (
  <div>
    <p className="mb-2 font-mono text-[11px] font-semibold uppercase tracking-wider text-slate-400">{label}</p>
    <div className="grid gap-2" style={{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }}>
      {options.map((o) => {
        const active = o.value === value;
        return (
          <button
            key={String(o.value)}
            type="button"
            disabled={o.disabled}
            data-testid={`${testPrefix}-${o.value}`}
            onClick={() => onChange(o.value)}
            className={`rounded-lg border px-3 py-2.5 text-left transition-colors disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-400 ${active ? "border-slate-900 bg-slate-900 text-white" : "border-slate-200 bg-white text-slate-700 hover:border-slate-400"}`}
          >
            <span className="block text-sm font-semibold">{o.label}</span>
            {o.hint && <span className={`mt-0.5 block text-[11px] leading-snug ${active ? "text-slate-300" : "text-slate-400"}`}>{o.hint}</span>}
          </button>
        );
      })}
    </div>
  </div>
);
